
interface menu{
    isTitle:boolean
    hasChildren:boolean
    title?:string
    name?:string
    key?:string
    status?:boolean
    route?:string
    children?: menu[],
    elements?: menu[]

}


export const Menu:menu[]=[
    {
        isTitle:true,
        title:"Vie Scolaire",
        hasChildren:false,
        status:false,
        elements:[
            {
                    isTitle:false,
                    name:"Tableau de bord",
                    route:'/professor-panel/accueil',
                    hasChildren:false,
                    status:false,
                    key:"professors-accueil",
                
                },
                
            {
                isTitle:false,
                name:"Mes données",
                hasChildren:true,
                status:false,
                children:[
                    {
                        isTitle:false,
                        name:"Emploi du temps",
                        route:'/professor-panel/timetables',
                        hasChildren:false,
                        status:false,
                        key:"professors-timetables",

                    },
                    {
                        isTitle:false,
                        name:"Liste des élèves",
                        route:'/professor-panel/claasroom-students-list',
                        hasChildren:false,
                        status:false,
                        key:"professors-claasroom-students-list",

                    },
                    {
                        isTitle:false,
                        name:"Liste des enseignants",
                        route:'/professor-panel/claasroom-professors-list',
                        hasChildren:false,
                        status:false,
                        key:"professors-classroom-professors-list",

                    },
                    {
                        isTitle:false,
                        name:"Liste du personnel",
                        route:'/professor-panel/professors-personal-list',
                        hasChildren:false,
                        status:false,
                        key:"professors-personal-list",

                    },
                    {
                        isTitle:false,
                        name:"Mon compte",
                        route:'/professor-panel/professors-account',
                        hasChildren:false,
                        status:false,
                        key:"professors-account",

                    }
                ]
            },   
                {
                isTitle:false,
                name:"Présence",
                hasChildren:true,
                status:false,
                children:[
                    {
                        isTitle:false,
                        name:"Cahier de présence",
                        route:'/professor-panel/attendances',
                        hasChildren:false,
                        status:false,
                        key:"professors-attendances",

                    },
                    {
                        isTitle:false,
                        name:"Faire l'appel",
                        route:'/professor-panel/attendance-create',
                        hasChildren:false,
                        status:false,
                        key:"professors-attendance-create",

                    },
                ]
            },    
              
        {
                isTitle:false,
                name:"Outils pédagogiques",
                hasChildren:true,
                status:false,

                children:[
                    {
                        isTitle:false,
                        name:"Ressources pédagogique",
                        route:'/professor-panel/educational-resources',
                        hasChildren:false,
                        status:false,
                        key:"professors-educational-resources",

                    },
                    {
                        isTitle:false,
                        name:"Forum pédagogique",
                        route:'/professor-panel/educational-forum',
                        hasChildren:false,
                        status:false,
                        key:"professors-educational-forum",

                    }
                ]
            },
        {
                isTitle:false,
                name:"Cahier de texte",
                hasChildren:true,
                status:false,
                children:[
                    {
                        isTitle:false,
                        name:"Saisie du cahier de texte",
                        route:'/professor-panel/textbook',
                        hasChildren:false,
                        status:false,
                        key:"professors-textbook",

                    },
                    {
                        isTitle:false,
                        name:"Planifier un devoir",
                        route:'/professor-panel/tasklists',
                        hasChildren:false,
                        status:false,
                        key:"professors-tasklists",
                    },

                    {
                        isTitle:false,
                        name:"Enregistrer un devoir",
                        route:'/professor-panel/note-create/1',
                        hasChildren:false,
                        status:false,
                        key:"professors-note-create",
                    },
                    {
                        isTitle:false,
                        name:"Consulter le cahier de note",
                        route:'/professor-panel/note-book',
                        hasChildren:false,
                        status:false,
                        key:"professors-note-book",

                    },
                    // {
                    //     isTitle:false,
                    //     name:"Suivi des acquis",
                    //     route:'/professor-panel/follow-up',
                    //     hasChildren:false,
                    //     status:false,
                    //     key:"professors-follow-up",

                    // },
                    {
                        isTitle:false,
                        name:"Vue élève",
                        route:'/professor-panel/tasklists-student-view',
                        hasChildren:false,
                        key:"professors-student-tasklists",
                        status:false,

                    }
                ]
            },
                {
                isTitle:false,
                name:"Notes",
                hasChildren:true,
                status:false,

                children:[
                    {
                        isTitle:false,
                        name:"Saisie des notes et appréciation",
                        route:'/professor-panel/note-create',
                        hasChildren:false,
                        status:false,
                        key:"professors-note-create",

                    },
                    {
                        isTitle:false,
                        name:"Relevé de notes",
                        route:'/professor-panel/note-index',
                        hasChildren:false,
                        status:false,
                        key:"professors-note-index",

                    },
                    {
                        isTitle:false,
                        name:"Saisie des appréciations par matière",
                        route:'/professor-panel/professors-appreciation',
                        hasChildren:false,
                        status:false,
                        key:"professors-appreciation",

                    },
                 
                    {
                        isTitle:false,
                        name:"Suivi des acquis",
                        route:'/professor-panel/follow-up',
                        hasChildren:false,
                        key:"professors-follow-up",

                    },
                ]
            },   
            {
                    isTitle:false,
                    name:"Bulletins",
                    hasChildren:true,
                    status:false,

                    children:[
                       
                        {
                            isTitle:false,
                            name:"Saisie des appréciations générales",
                            route:'/professor-panel/professors-bulletin-appreciation',
                            hasChildren:false,
                            status:false,
                            key:"professors-bulletin-appreciation",

                        },
                        {
                            isTitle:false,
                            name:"Bulletin par éléve",
                            route:'/professor-panel/professors-bulletin',
                            hasChildren:false,
                            status:false,
                            key:"professors-bulletin",

                        }
                    ]
                },
        ]
    },
   
  
   
  
 

   
  
  
    // {
    //     isTitle:false,
    //     name:"Résultats",
    //     hasChildren:true,
    //     children:[
           
    //     ]
    // },
    // {
    //     isTitle:false,
    //     name:"Vie scolaire",
    //     hasChildren:true,
    //     children:[
           
    //     ]
    // },
    // {
    //     isTitle:false,
    //     name:"Communications",
    //     hasChildren:true,
    //     children:[
            
    //     ]
    // },
]
